(() => {
  function moveFastBundle() {
    const fastBundle = document.querySelector("#rbr-container-element-false");
    const fastBundleHolder = document.querySelector(".js-fast-bundle-holder");

    if (!fastBundle) {
      fastBundleHolder.classList.add("hidden");
      return;
    }
    fastBundle.append(fastBundleHolder);

    fastBundleHolder.classList.remove("hidden");

    const fastBundleContent = document.querySelector(".rbr-page-container");
    const newParentContent = document.querySelector(".js-fast-bundle-content");
    newParentContent.append(fastBundleContent);

    const fastBundleTitle = document.querySelector(
      ".rbr-standard-bundle__title"
    );
    const newParentTitle = document.querySelector(".js-fast-bundle-heading");

    newParentTitle.append(fastBundleTitle);
  }

  function waitForElm(selectors) {
    return new Promise((resolve) => {
      if (selectors.reduce((acc, sel) => document.querySelector(sel) && acc)) {
        return resolve();
      }

      const observer = new MutationObserver((mutations) => {
        if (
          selectors.reduce((acc, sel) => document.querySelector(sel) && acc)
        ) {
          observer.disconnect();
          resolve();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }
  waitForElm([
    "#rbr-container-element-false",
    ".rbr-page-container",
    ".rbr-standard-bundle__title",
  ]).then(() => {
    moveFastBundle();
  });
})();
